import { getApiPath } from '@/shared/api/constants';

const REPORT_API_NAME = 'report';
const TASK = '/task';
const TASK_INDIVIDUAL = '/taskIndividual';
const TASK_CONTROL = '/taskControl';
const DOWNLOAD = '/download';
const SUMMARY = '/summary';
const ARCHIVED = '/archived';
const MORTALITY = '/mortality';
const AUTOPSY = '/autopsy';

const REPORT_API = getApiPath(REPORT_API_NAME);
/* task-report-search-controller */

export const TASK_REPORT = REPORT_API + TASK;

export const TASK_REPORT_DOWNLOAD = TASK_REPORT + DOWNLOAD;

/* task-individual-report-search-controller */

export const TASK_INDIVIDUAL_REPORT = REPORT_API + TASK_INDIVIDUAL;
export const TASK_INDIV_DOWNLOAD = TASK_INDIVIDUAL_REPORT + DOWNLOAD;
export const TASK_INDIV_ARCHIVED_DOWNLOAD = TASK_INDIVIDUAL_REPORT + ARCHIVED + DOWNLOAD;

/* task-control-report-search-controller */
export const TASK_CONTROL_REPORT = REPORT_API + TASK_CONTROL + DOWNLOAD;

/* summary-report-search-controller */

export const FREE_REPORT = REPORT_API + SUMMARY;

export const FREE_REPORT_DOWNLOAD = FREE_REPORT + DOWNLOAD;

/* mortality-report-search-controller */

export const MORTALITY_REPORT = REPORT_API + MORTALITY;

export const MORTALITY_REPORT_DOWNLOAD = MORTALITY_REPORT + DOWNLOAD;

/* autopsy-act-report-controller */

export const AUTOPSY_ACT_DOWNLOAD = (actId: string) =>
  REPORT_API + AUTOPSY + `/${actId}` + DOWNLOAD;
